<template>
  <div class="rating" :style="allStyles">
    <span>{{ rating }}</span>
    <slot />
  </div>
</template>

<script>
import mixins from "@/mixins";

export default {
  name: "ScoreCircle",
  mixins: [mixins],
  props: {
    rating: {
      type: [String, Number],
      default: ""
    },
    size: {
      type: String,
      default: "2.7rem"
    }
  },
  data() {
    return {
      ratingStyle: ""
    };
  },
  computed: {
    allStyles() {
      return `${this.ratingStyle}; width: ${this.size}; min-width: ${this.size}; height: ${this.size}; font-size: calc(${this.size} / 2.7); --inset: calc(${this.size} / 15);`;
    }
  },
  mounted() {
    const ratingColor = this.convertScoreToColor(this.rating);

    this.ratingStyle =
      this.rating == 100
        ? "background: " + ratingColor
        : "background: conic-gradient(" +
          ratingColor +
          " " +
          this.rating +
          "%, #757575 0 100%)";
  }
};
</script>

<style lang="scss" scoped>
/* Rating item */
.rating {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(1, 1, 1, 0.3), 0 2px 4px rgba(1, 1, 1, 0.2),
    0 3px 3px -4px rgba(1, 1, 1, 0.18);
}

/* Rating circle content */
.rating span {
  position: relative;
  display: flex;
  font-weight: bold;
  z-index: 2;
  margin-bottom: 1px;
}

.rating span small {
  font-size: 0.5em;
  font-weight: 900;
  align-self: center;
}

/* Bar mask, creates an inner circle with the same color as thee background */
.rating::after {
  content: "";
  position: absolute;
  inset: var(--inset, 0.18rem);
  background: #242526;
  border-radius: inherit;
  z-index: 1;
}

/* Bar background */
.rating::before {
  content: "";
  position: absolute;
  inset: var(--inset, 0.18rem);
  border-radius: inherit;
  box-shadow: 0 0 0 1rem #c7e1f3;
  z-index: -1;
}

/* Classes to give different colors to ratings, based on their score */
.rating.good {
  background: #27ae60;
}

.rating.meh {
  background: #f1c40f;
}

.rating.bad {
  background: #e74c3c;
}
</style>
